import $ from 'jquery';
import SelectedJobsState from './SelectedJobsState';
import Quote from './Quote';
import EventBus from '../../common/EventBus';

const SELECTORS = {
  nextStep: '.js-next-step',
  unquotedPartsMir: '.unquoted-parts-mir-cta',
  workBasketNextStep: '.work-basket-next-step',
};

export default class WorkCta {
  constructor() {
    this.selectedJobsState = new SelectedJobsState();
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    EventBus.on('quote:fetching-start', () => this.startFetchingQuote());
    EventBus.on('quote:fetching-end', (data) => this.endFetchingQuote(data.quote));
  }

  startFetchingQuote() {
    $(SELECTORS.nextStep).prop('disabled', true);
    $(SELECTORS.unquotedPartsMir).addClass('hidden');
    $(SELECTORS.workBasketNextStep).removeClass('hidden');
  }

  endFetchingQuote(data) {
    if (this.selectedJobsState.selectedJobs().length) {
      $(SELECTORS.nextStep).prop('disabled', false);
    }

    const quote = new Quote(data);
    if (quote.unquotedParts().length) {
      $(SELECTORS.unquotedPartsMir).removeClass('hidden');
      $(SELECTORS.workBasketNextStep).addClass('hidden');
    }
  }
}
